
import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface AuthSubmitButtonProps {
  loading: boolean;
  mode: "signin" | "signup";
}

const AuthSubmitButton: React.FC<AuthSubmitButtonProps> = ({ loading, mode }) => (
  <Button 
    type="submit" 
    className="w-full h-12 md:h-14 bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary/70 text-white font-bold text-base md:text-lg rounded-lg md:rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-[1.01] md:hover:scale-[1.02]" 
    disabled={loading}
  >
    {loading && <Loader2 className="mr-2 md:mr-3 h-5 w-5 md:h-6 md:w-6 animate-spin" />}
    {mode === "signin" ? "Sign In to TeenVisor" : "Create Your Account"}
  </Button>
);

export default AuthSubmitButton;
